import pLimit from "p-limit";
import { SongUb } from "../gql/graphql";
import { chordsheetPersistenceState } from "./ChordsheetPersistenceState";
import {
  transformAndPersistChordsheet,
  getPersistedChordsheetIds,
} from "./LyricsPartsPersistence";

export async function startBackgroundJobPersistChordsheetsOfSongs(
  allSongsFromCache: readonly SongUb[],
  deltaSongs: readonly SongUb[],
): Promise<void> {
  if (chordsheetPersistenceState.getStatus() === "running") {
    return;
  }
  chordsheetPersistenceState.setStatus("running");

  try {
    const songsMap = new Map<string, SongUb>();
    for (const song of allSongsFromCache) {
      songsMap.set(song.id, song);
    }
    for (const song of deltaSongs) {
      songsMap.set(song.id, song);
    }
    const allSongs = Array.from(songsMap.values());

    const deltaIds = new Set(deltaSongs.map((song) => song.id));
    let cachedSongIds = new Set<string>();
    try {
      cachedSongIds = await getPersistedChordsheetIds();
    } catch (error) {
      console.warn(
        "Failed to get persisted chordsheet IDs, proceeding with empty cache set:",
        error,
      );
    }

    const songsToPersist = allSongs.filter((song) => {
      if (!song.chordsheet) {
        return false;
      }
      if (deltaIds.has(song.id)) {
        return true;
      }
      return !cachedSongIds.has(song.id);
    });

    const limit = pLimit(10);
    const results = await Promise.allSettled(
      songsToPersist.map((song) =>
        limit(() => transformAndPersistChordsheet(song.id, song.chordsheet!)),
      ),
    );

    let hasErrors = false;
    results.forEach((result, index) => {
      if (result.status === "rejected") {
        hasErrors = true;
        const song = songsToPersist[index];
        console.error(
          `Failed to transform/persist chordsheet for song ${song.id}:`,
          result.reason,
        );
      }
    });

    chordsheetPersistenceState.setStatus(hasErrors ? "failed" : "completed");
  } catch (error) {
    console.error("Failed background chordsheet persistence:", error);
    chordsheetPersistenceState.setStatus("failed");
  }
}
